exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-336058f2] {\n  width: 100%;\n  height: auto;\n}\n", ""]);

// exports
